export default __webpack_public_path__ + "static/media/empty_sms.626c6c98.svg";